export default __webpack_public_path__ + "f2a3adcac6410bda6751c477467829c6.png";